import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, hasNavAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-[#09090B] border-t-[#FFCC00] mx-auto mb-4"></div>
          <p className="text-lg font-medium text-[#09090B]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based page access
  if (!hasNavAccess(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return React.cloneElement(children, { user });
};

export default ProtectedRoute;
